import type { Notification } from "@circle-react/types/Notification";
import { Link } from "@tanstack/react-router";

import { useIsUnifiedInboxRoute } from "@/react/hooks/chatsV2/messaging/useIsUnifiedInboxRoute";

import { DefaultNotificationContent } from "./DefaultNotificationContent";

export const DefaultNotification = ({
  notification,
  onClickHandler,
  isMarkedAsRead,
}: {
  notification: Notification;
  onClickHandler: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  isMarkedAsRead: boolean;
}) => {
  // Inside the inbox, prefer the inbox-specific destination computed by the
  // backend (Notifications::GetNotifiableInboxPathService); elsewhere use the
  // community path.
  const isUnifiedInboxRoute = useIsUnifiedInboxRoute();
  const effectivePath =
    isUnifiedInboxRoute && notification.action_inbox_path
      ? notification.action_inbox_path
      : notification.action_web_path;

  return (
    <Link
      to={effectivePath}
      onClick={onClickHandler}
      state={{ from: { path: "/notifications" } }}
      className="w-full"
    >
      <DefaultNotificationContent
        notification={notification}
        isMarkedAsRead={isMarkedAsRead}
      />
    </Link>
  );
};
